import { Car, Droplets, Coffee, Shirt, Wifi, Lock, Armchair, Snowflake, Video, HeartPulse } from 'lucide-react';

// Photo sections shared by Site Builder (upload slots + caps) and the public
// page (which section renders where). Section ids are stored on gallery items
// — never rename (additive only). Caps sum to 20 = the backend gallery cap.
export const PHOTO_SECTIONS = {
  facility: { label: 'Facility & vibe', max: 6, hint: 'Facade, ambiance, night shots — these play in the home page strip' },
  courts: { label: 'Courts', max: 6, hint: 'Each court, surfaces, nets — shown in the Our Courts collage' },
  amenities: { label: 'Amenities', max: 4, hint: 'Parking, showers, lounge, shop' },
  events: { label: 'Events & community', max: 4, hint: 'Tournament nights, open play crowds — shown on the Events page' },
};

// Amenity picklist shared by the public page and Site Builder. Ids are stored
// in settings.site_builder.amenities — never rename an id (additive only).
export const AMENITIES = {
  parking: { label: 'Parking', Icon: Car },
  showers: { label: 'Showers', Icon: Droplets },
  drinks: { label: 'Drinks & snacks', Icon: Coffee },
  rentals: { label: 'Equipment rental', Icon: Shirt },
  wifi: { label: 'Free WiFi', Icon: Wifi },
  lockers: { label: 'Lockers', Icon: Lock },
  waiting: { label: 'Waiting area', Icon: Armchair },
  aircon: { label: 'Air-conditioned', Icon: Snowflake },
  cctv: { label: 'CCTV secured', Icon: Video },
  firstaid: { label: 'First aid kit', Icon: HeartPulse },
};
